import { createIntlScope } from '../IntlScope';
import { de } from './de';
import { en } from './en';

export const { FormattedMessage, formatMessage } = createIntlScope({
  en,
  de,
});
